<div class="flex-column gap-10">
    <app-command-list-item-template></app-command-list-item-template>
    <app-command-list-item-template></app-command-list-item-template>
    <app-command-list-item-template></app-command-list-item-template>
    <app-command-list-item-template></app-command-list-item-template>
    <app-command-list-item-template></app-command-list-item-template>
    <app-command-list-item-template></app-command-list-item-template>

</div>